import { Status } from '@/models/CommonModels';

import { MutationTree } from 'vuex';
import { State } from './state';

export enum MutationTypes {
  SetStatus = 'SETSTATUS',
  SetQRCodeTrennzeichen = 'SETQRCODETRENNZEICHEN',
}

export type Mutations = {
  [MutationTypes.SetStatus](state: State, status: Status): void;
  [MutationTypes.SetQRCodeTrennzeichen](state: State, data: string): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SetStatus](state: State, status: Status) {
    state.status = status;
  },

  [MutationTypes.SetQRCodeTrennzeichen](state: State, data: string) {
    if (data == undefined || data == '') {
      state.qrCodeTrennzeichen = '_';
    } else {
      state.qrCodeTrennzeichen = data;
    }
  },
};
